
<template>
<div class="s4s-page" style="padding-top: 15px;">

    <div class="s4s-form-body">
      <!-- <div class="s4s-uplaod" style="margin-top: -10px;">
          <div class="s4s-uplaod-content" @click="uploadImage">
              <img class="s4s-uplaod-pic" src="../assets/icon/uploadPic.png" mode="aspectFit"  />
              <span class="s4s-uplaod-span">扫描行驶证</span>
              <input
              ref="file"
              type="file"
              accept="image/*"
              multiple="multiple"
              style="display: none;"
              @change="fileChanged">
              <canvas id="canvas" style="display: none;"></canvas>
          </div>
        </div>
        <div style="display:block;text-align:center;color: #BAC0C6;font-size:13px;margin-top:16px;">上传或拍摄行驶证照片，自动录入信息</div> -->
        <div class="s4s-group" style="margin-top: 10px;">
          <span class="s4s-group-tit">车辆类型</span>
            <span class="s4s-group-txt" @click="selectCarType"  style="text-align: right">
                {{carType.value}}
                <img src="../assets/icon/right-icon.png" class="s4s-arr-bottom1"/>
            </span>
              <awesome-picker
              ref="picker"
              :type="picker.type"
              :data="picker.data"
              :anchor="picker.anchor"
              :textTitle="picker.textTitle"
              :textConfirm="picker.textConfirm"
              :textCancel="picker.textCancel"
              :swipeTime="picker.swipeTime"
              :colorTitle="picker.colorTitle"
              :colorConfirm="picker.colorConfirm"
              :colorCancel="picker.colorCancel"
              @cancel="handlePickerCancel"
              @confirm="handlePickerConfirm">
            </awesome-picker>
        </div>
        <div :class="isCarnoTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'">
          <span class="s4s-group-tit">车牌号码</span>
          <div style="display: flex;align-items:center;">
            <div class="s4s-sel-provice" style="float: left;">
              <span @click="selectProvice">{{ provice }}</span>
              <div class="triangle-button"></div>
            </div>
            <input type="span"  @focus="showProvice = false"
            name="carno" maxlength="7" v-model="carno"
            placeholder="请输入车牌号码" style="text-transform:uppercase;"  />
          </div>
        </div>
        <!-- <div v-if="vinLength > 0"   :class="isVinTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'"> -->
        <div :class="isVinTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'">
          <div class="s4s-group-tit">车架号码
            <span class="s4s-help" @click="classDetail"></span>
          </div>
          <input   type="span"   @focus="showProvice = false"  name="vin" v-model="vin"
          :placeholder="vinPlaceholder" style="text-transform:uppercase;" maxlength="17" minlength='17' />

        </div>
        <!-- <div v-if="engineNoLength > 0"
          :class="isEngineTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'"> -->
        <div :class="isEngineTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'">
          <div class="s4s-group-tit">发动机号
            <span class="s4s-help" @click="engineDetail"></span>
          </div>
          <input   type="span"
          @focus="showProvice = false" name="engion" v-model="engion"
          :placeholder="enginePlaceholder" style="text-transform:uppercase;" minlength="6" maxlength="16" />

      </div>
      <div :class="isEngineTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'">
        <div class="s4s-group-tit">注册日期</div>
        <van-button  @click="dataChoose" style="border: none;padding-left:0;padding-right:0;color: #9c9ea8" :class="dataChange=='请选择日期' ? 'choose' : 'data'">{{dataChange?dataChange:'请选择日期'}}
          <img src="../assets/icon/right-icon.png" class="s4s-arr-bottom1"/>
        </van-button>
        <van-popup v-model="showPop" :get-container="getContainer" position="bottom"  overlay>
          <van-datetime-picker v-model="currentDate" type="date" @confirm="confirms" @cancel="cancels" :min-date="minDate"/>
        </van-popup>
      </div>


    </div>


    <div v-if="error" class="s4s-error">{{error}}</div>
    <button class="s4s-btn" style="margin-top:50px;"
    @click="formSubmit" hover-class="defaultTap"  :style="{backgroundImage:advertisingShow.backgroundImage,opacity:opacity}" :disabled="disabled"> 保存爱车 </button>

      <div v-if="showCaptcha" class="captcha">
        <div class="s4s-mask" />
         <div class="captcha-container">
             <div class="captcha-title">请输入验证码</div>
             <img
              :src="captchUrl"
              style="width: 272px;height: 90px;"
              @click="getCaptcha"/>
            <div
              class="captcha-change"
              @click="getCaptcha">看不清？换一张</div>
            <div class="captcha-input-container" bindtap="foucsShowCaptcha">
                <div v-for="item in captchValue"
                :key="item.id"
                class="captcha-input"
                    >
                    {{item||''}}
                </div>
            </div>
            <div class="captcha-keyboard">
              <div class="captcha-key-list"  v-for="item in captchKeyArray" :key="item.id" >
                  <button v-for="ele in item" :key="ele"
                  class="captcha-key"
                  @click="onInputCaptcha(ele)">
                  {{ele}}
                </button>
              </div>
              <div class="captcha-key-list">
                    <button class="captcha-key">

                  </button>
                  <button class="captcha-key" @click="onInputCaptcha('0')">
                      0
                  </button>
                  <button class="captcha-key" @click="onInputCaptcha('←')" >
                      ←
                  </button>
              </div>
            </div>
        </div>
    </div>
     <!-- 选择省份键盘 start -->
  <Provice :show="showProvice"
  @on-status-change="onProviceStatusChange"
  @on-result-change="onProviceResultChange"  />
  <!-- 选择省份键盘 end -->
  <div class="s4s-mask" @click="hideImage" v-if="helpImageSrc">
    <img :src="helpImageSrc" class="s4s-mask-image" />
  </div>
</div>
</template>
<script>
// @ is an alias to /src
import Provice from '@/components/Provice.vue';
import advertisingShow from './../utils/advertising';
import { DatetimePicker, Popup, Button } from 'vant';

export default {
  name: 'addcar',
  components: {
    Provice,
    DatetimePicker,
    Popup,
    Button,
  },
  data() {
    return {
      minDate: new Date(2000, 1, 1),
      showPop: false,
      currentDate: new Date(),
      dataChange: '请选择日期',
      opacity: 1,
      disabled: false,
      car: null,
      provice: '京',
      showProvice: false,
      carno: '',
      engion: '',
      vin: '',
      detail: false,
      src: '',
      engineNoLength: 0,
      vinLength: 0,
      vinPlaceholder: '请输入完整的车架号',
      enginePlaceholder: '请输入完整的发动机号',
      error: '',
      isCarnoTrue: true,
      isVinTrue: true,
      isEngineTrue: true,
      showCaptcha: false,
      advertisingShow: advertisingShow(),
      picker: {
        // anchor: [],
        data: [
          { value: '小型轿车', id: '02' },
          { value: '大型汽车', id: '01' },
          { value: '中国香港入境车', id: '26' },
          { value: '中国澳门入境车', id: '27' },
          { value: '新能源大车', id: '51' },
          { value: '新能源小车', id: '52' }],
        // anchor:'',
        textConfirm: '确认',
        textCancel: '取消',
        swipeTime: 1800,
        colorConfirm: '#3A82FF',
        colorTitle: '',
      },
      carType: { value: '小型轿车', id: '02' },
      captchUrl: '',
      captchKey: '',
      captchValue: ['', '', '', ''],
      captchKeyArray: [[1, 2, 3], [4, 5, 6], [7, 8, 9]],
      helpImageSrc: '',
    };
  },
  watch: {
    provice(val) {
      // this.$request('v3/violation/rule', {
      //   prefix: val,
      // }).then((xhr, res) => {
      //   if (res.code === 20022) {
      //     return;
      //   }
      //   if (res.code >= 40000 && res.code < 50000) {
      //     return;
      //   }
      //   if (res.code === 0) {
      //     this.vinLength = res.data.vinLength;
      //     this.engineNoLength = res.data.engineNoLength;
      //   }
      // });
      this.getRule(val);
    },
  },
  computed: {
    carList() {
      return this.$store.state.carList;
    },
  },
  mounted() {
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '1', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '编辑车辆'
      });
    }

    if (this.$route.query.proviceCarno) {
      this.provice = this.$route.query.proviceCarno.substring(0, 1);
      this.carno = this.$route.query.proviceCarno.substring(1);
      this.engion = this.$route.query.engion;
      this.vin = this.$route.query.vin;
      this.dataChange = this.$route.query.registe_time;
      const carTypeId = this.$route.query.carType;
      this.picker.data.forEach((item, index) => {
        if (item.id == carTypeId) {
          this.carType = item;
        }
      });
    }

    this.getRule(this.provice);
  },
  methods: {
    getContainer() {
      return document.querySelector('.s4s-form-body');
    },
    // 选择日期
    dataChoose() {
      this.showPop = true;
    },
    // 选择日期的确认按钮
    confirms(value) {
      const date = value;
      const Y = `${date.getFullYear()}-`;
      let M = (date.getMonth() + 1);
      let D = `${date.getDate()} `;
      if (M < 10) {
        M = `0${M}`;
      }
      if (D < 10) {
        D = `0${D}`;
      }
      this.dataChange = `${Y + M}-${D}`;
      this.showPop = false;
    },
    // 选择日期的取消按钮
    cancels() {
      this.showPop = false;
    },
    selectProvice() {
      this.showProvice = !this.showProvice;
    },
    onProviceStatusChange(val) {
      this.showProvice = val;
    },
    // onProviceResultChange(val) {
    //   this.provice = val;
    // },
    onProviceResultChange(val) {
      const arr = ['晋', '黑', '云', '甘', '藏', '警', '学', '港', '澳', '使'];
      this.provice = val;
      if (arr.indexOf(val) != -1) {
        this.$showToast({ title: '暂不支持' });
        this.disabled = true;
        this.opacity = 0.5;
        return;
      }
      this.disabled = false;
      this.opacity = 1;
    },
    handlePickerCancel() {},
    handlePickerConfirm(e) {
      const [first] = e;
      this.carType = this.picker.data[first.index];
      // this.form.time = e[0].value + "-" + e[1].value + "-" + e[2].value;
    },
    engineDetail() {
      this.showImage('https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/img/engine.png');
    },
    classDetail() {
      this.showImage('https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/img/classNo.png');
    },
    // 关闭蒙层
    hideImage() {
      this.helpImageSrc = '';
    },
    // 发动机详情
    showImage(src) {
      this.helpImageSrc = src;
    },
    selectCarType() {
      this.showProvice = false;
      this.$refs.picker.show();
    },
    formSubmit() {
      const self = this;
      this.clearError();

      const proviceCarno = self.carno ? (self.provice + self.carno) : '';
      const vin = self.vin || '';
      const engion = self.engion || '';
      const carType = self.carType.id || '';
      if (proviceCarno.length !== 7 && proviceCarno.length !== 8) {
        self.isCarnoTrue = false;
        self.error = '车牌号码错误，请输入正确的车牌号。';
        return;
      }

      // for (let i = 0; i < self.carList.length; i += 1) {
      //   if (proviceCarno !== self.carList[i].proviceCarno) {
      //     self.isCarnoTrue = false;
      //     self.error = `车牌号码错误，已有相同车牌号码${proviceCarno.toUpperCase()}`;
      //     return;
      //   }
      // }
      if (self.vinLength > 0 && vin.length < 6) {
        self.isVinTrue = false;
        self.error = '车架号码错误，请输入正确的车架号。';
        return;
      }
      if (self.engineNoLength > 0 && engion.length < 6) {
        self.isEngineTrue = false;
        self.error = '发动机号码错误，请输入正确的发动机号码。';
        return;
      }

      if (!this.$store.getters.userInfo || !this.$store.getters.token) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/',
            proviceCarno,
            vin,
            engion,
            carType,
          },
        });
        return;
      }
      if (this.dataChange == '' || this.dataChange == '请选择日期') {
        self.isEngineTrue = false;
        self.error = '请选择日期';
        return;
      }
      const param = {
        car_type: carType,
        car_no: proviceCarno ? proviceCarno.toUpperCase() : '',
        vin: vin ? vin.toUpperCase() : '',
        engine: engion ? engion.toUpperCase() : '',
      };
      self.carInfoSubmit(param);
    },
    uploadImage() {
      this.showProvice = false;

      this.$refs.file.click();
    },
    fileChanged() {
      const self = this;
      const list = this.$refs.file.files;
      if (list.length !== 1) {
        this.$showToast({ title: '最多只能选择1张行驶证。' });
      }
      const item = {
        name: list[0].name,
        size: list[0].size,
        file: list[0],
      };
      self.html5Reader(list[0], item);
    },
    html5Reader(file, item) {
      const that = this;
      const imgSrc = new Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        imgSrc.src = e.srcElement.result;
        that.$set(item, 'src', e.srcElement.result);
        imgSrc.onload = function () {//eslint-disable-line
          // 图片原始尺寸
          const originWidth = this.width;
          const originHeight = this.height;
          // 最大尺寸限制
          const maxWidth = 2000;
          const maxHeight = 2000;
          // 目标尺寸
          let targetWidth = originWidth;
          let targetHeight = originHeight;
          // 图片尺寸超过400x400的限制
          if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
              // 更宽，按照宽度限定尺寸
              targetWidth = maxWidth;
              targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
              targetHeight = maxHeight;
              targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
          }
          const canvas = document.getElementById('canvas');
          const context = canvas.getContext('2d');
          // canvas对图片进行缩放
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          // 清除画布
          context.clearRect(0, 0, targetWidth, targetHeight);
          // 图片压缩
          context.drawImage(imgSrc, 0, 0, targetWidth, targetHeight);
          // canvas转为blob并上传
          const data = canvas.toDataURL('image/jpeg').split(',')[1];
          // 获取base64图片大小，返回MB数字
          const size = parseInt(data.length - data.length / 8 * 2);//eslint-disable-line
          console.log(size);
          if (size) {
            const isLt2M = size / 1024 / 1024 < 2;
            if (!isLt2M) {
              that.$showToast({ title: '图片大小需要小于 2MB!' });
              return;
            }
            that.$showToast({ title: '正在上传', duration: 10000 });
            that.vehiclecardFetch(data);
          }
        };
      };
      reader.readAsDataURL(file);
    },
    vehiclecardFetch(data) {
      // 识别行驶证
      const self = this;
      this.$requestPost('v3/violation/driver/recognition', {
        imageString: data,
      })
        .then((xhr, res) => {
          this.$hideToast();
          if (res.code === 0) {
            if (res.data && res.data[0]) {
              this.$showToast({ title: '行驶证识别成功，请您核对信息是否准确' });
              this.vehicleInfo(res.data[0]);
            } else {
              this.$showToast({ title: '行驶证图片识别失败，请再次拍照识别或手动输入' });
            }
          } else {
            this.$showToast({ title: res.msg });
          }
        }).catch((e) => {
          console.log(e);
          this.$hideToast();
        });
    },
    vehicleInfo(val) {
      // 匹配车辆信息
      this.car = val;
      this.provice = val.CarNo ? val.CarNo.substring(0, 1) : '浙';
      this.carno = val.CarNo ? val.CarNo.substring(1) : '';
      this.vin = val.Vin || '';
      this.engion = val.Engion || '';
      this.dataChange = val.RegisterDate || '';
      const carType = val.CarType;

      // 查找车辆类型 装填
      for (let i = 0; i < this.picker.data.length; i += 1) {
        if (carType === this.picker.data[i].value) {
          this.carType = this.picker.data[i];
          return;
        }
      }
    },
    clearError() {
      // 错误初始化
      this.isCarnoTrue = true;
      this.isVinTrue = true;
      this.isEngineTrue = true;
      this.error = '';
    },
    getIllegal({
      proviceCarno, vin, engion, carType,
    }) {
      if (!proviceCarno) {
        this.records = [];
        this.illegal = {
          CarNo: '',
          Fine: 0,
          total: 0,
          degree: 0,
          fine: 0,
        };
        return;
      }
      const self = this;
      self.showCaptcha = false;
      const param = {
        // formid: '',
        car_no: proviceCarno ? proviceCarno.toUpperCase() : '',
        vin: vin ? vin.toUpperCase() : '',
        engine: engion ? engion.toUpperCase() : '',
      };

      if (carType) {
        // 如果有车辆类型
        param.car_type = carType;
      }
      if (self.needCaptcha) {
        // 如果需要验证码
        param.key = self.captchKey;
        param.value = self.captchValue.join('');
      }
      self.$showLoading({
        title: '正在查询',
      });

      self.$requestPost('v3/violation/web/query', param).then((xhr, res) => {
        self.$hideLoading();
        if (res.code === 90027) {
          // 需要验证码 90027
          this.showCaptcha = true;
          this.needCaptcha = true;
          this.provice = param.car_no.substring(0, 1);
          this.carno = param.car_no.substring(1);
          this.vin = param.vin;
          this.engion = param.engine;
          self.$showToast({
            icon: 'none',
            title: '需要填写验证码',
          });
          self.getCaptcha(param);
        } else if (res.code !== 0) {
          this.records = [];
          this.illegal = {
            CarNo: '',
            Fine: 0,
            total: 0,
            degree: 0,
            fine: 0,
          };
          self.$showToast({
            icon: 'none',
            title: res.msg,
          });
        } else if (res.code === 0 && res.data) {
          self.carInfoSubmit(param);
          this.records = res.data.Records || [];
          this.illegal = {
            CarNo: param.car_no,
            Fine: res.data.Fine,
            total: res.data.Total || 0,
            degree: res.data.Degree || 0,
            fine: res.data.Fine || 0,
          };
          this.showCaptcha = false;
          this.needCaptcha = false;
        }
      }).catch((e) => {
        console.log(e);
        self.$hideLoading();
      });
    },
    carInfoSubmit(carInfo) {
      // const self = this;
      // for (let i = 0; i < self.carList.length; i += 1) {
      //   if (carInfo.car_no !== self.carList[i].proviceCarno) {
      //     return;
      //   }
      // }
      const param = {
        car_no: carInfo.car_no,
        vin: carInfo.vin,
        engine: carInfo.engine,
        car_type: carInfo.car_type,
        registe_time: this.dataChange,
      };

      this.$store.commit('SET_SCOTT_CAR_PARAM', param);
      this.$request('v3/violation/car/manage', param).then((xhrr, ress) => {
        if (ress.code === 0) {
          this.$showToast({
            title: '编辑成功',
          });
          // this.$store.commit('SET_CARLIST', []);
          // this.$store.dispatch('getCar').then(() => {
          this.$router.replace({
            path: this.$route.query.redirect ? this.$route.query.redirect : '/carList',
          });
          // });
        } else {
          this.$showToast({
            icon: 'none',
            title: ress.msg,
          });
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    getCaptcha() {
      const that = this;
      that.$request('v3/captcha', {
        width: 180,
        height: 80,
        cap_len: 4,
        dot_count: 80,
        skew: 1,
      }).then((xhr, res) => {
        if (res.code === 0) {
          that.captchKey = res.data.key;
          that.captchUrl = res.data.image;
          that.captchValue = ['', '', '', ''];
        } else {
          setTimeout(() => {
            this.$showToast({
              icon: 'none',
              title: res.msg, // 文字内容
            });
          }, 0);
          that.captchValue = ['', '', '', ''];
        }
      }).catch(() => {
        that.$showToast({
          icon: 'none',
          title: '需要填写验证码.', // 文字内容
        });
        that.captchValue = ['', '', '', ''];
      });
    },
    getRule(val) {
      this.$request('v3/violation/rule', {
        prefix: val,
      }).then((xhr, res) => {
        if (res.code === 20022) {
          return;
        }
        if (res.code >= 40000 && res.code < 50000) {
          return;
        }
        if (res.code === 0) {
          this.vinLength = res.data.vinLength;
          this.engineNoLength = res.data.engineNoLength;
          // if (res.data.vinLength > 0) {
          //   this.vinPlaceholder = res.data.vinLength === 99 ? '请输入完整的车架号' : `请输入车架号后${res.data.vinLength}位`;
          // }
          // if (res.data.engineNoLength > 0) {
          //   this.enginePlaceholder = res.data.engineNoLength === 99 ? '请输入完整的发动机号' : `请输入发动机号后${res.data.engineNoLength}位`;
          // }
        }
      });
    },
    onInputCaptcha(value) {
      let arr = [...this.captchValue];
      let index = 3;
      if (value === '←') {
        const string = [...this.captchValue].join('');
        const newString = string.substring(0, string.length - 1);
        arr = [newString[0] || '', newString[1] || '', newString[2] || '', newString[3] || ''];
        this.captchValue = arr;

        return;
      }
      if (this.captchValue[3]) {
        return;
      }
      if (!this.captchValue[0]) {
        index = 0;
      } else if (!this.captchValue[1]) {
        index = 1;
      } else if (!this.captchValue[2]) {
        index = 2;
      } else if (!this.captchValue[3]) {
        index = 3;
      }
      arr[index] = value;

      // swan.showToast({
      //   title: arr
      // })
      this.captchValue = arr;
      if (arr[3]) {
        this.getIllegal({
          proviceCarno: this.provice + this.carno,
          vin: this.vin,
          engion: this.engion,
          carType: this.carType && this.carType.id,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/* @import "../illegal/illegal.acss"; */
.x{
  width: 16px;
  height: 16px;
}
.x_plate{
  width: 16px;
  height: 16px;
  margin-right: 24px;
}
.s4s-authorized {
  margin: 5px 15px;
}
.s4s-illegal-bg {
  background: #00a1ee url(../assets/icon/head_bg.png) no-repeat left bottom / 100%
    28px;
  width: 100%;
  height: 100px;
}
.s4s-photo {
  padding: 5px 0;
  display: flex;
  margin: -100px auto 0 auto;
  color: #fff;
  overflow: hidden;
  flex-direction: column;
  text-align: center;
}

.s4s-photo image {
  width: 10px;
  height: 10px;
  padding: 5px;
}
.s4s-index-pic {
  width: 80px;
  height: 50px;
}
.s4s-illegal-body {
  margin: 0 10px 10px 10px;
  background: #fff;
  border-radius: 4px;
  padding: 0 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.s4s-car-sel {
  border: 1px rgba(0, 161, 238, 0.23) solid;
  color: #00a1ee;
  padding: 3px 5px;
  border-radius: 3px;
  font-size: 14px;
  align-self: flex-end;
}
.s4s-car-info {
  background-color: #fff;
  padding: 10px;
  margin: 10px 10px 0 10px;
  border-radius: 7px;
  font-size: 15px;
}
.s4s-car-model {
  display: flex;
  align-items: center;
}
.s4s-car-name {
  flex: 1;
  color: #00a1ee;
  font-size: 17px;
}
.s4s-car-illegal {
  padding-top: 10px;
  padding-left: 5px;
  color: #00a1ee;
  font-size: 14px;
}
.s4s-car-select {
  padding-top: 10px;
  color: #00a1ee;
  font-size: 13px;
  text-align: center;
  text-decoration: underline;
  font-weight: bold;
}

.s4s-car-illegal text {
  color: #f40;
}
.s4s-tit-hd {
  display: flex;
}
.s4s-right {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.s4s-right-txt {
  font-size: 13px;
  color: #aaa;
  display: block;
}
.s4s-illegal-item {
  display: flex;
  margin: 0 10px 10px 10px;
}

.s4s-illegal-icon {
  width: 11px;
  height: 15px;
}
.s4s-illegal-addr {
  flex: 1;
  font-size: 14px;
  color: #666;
  padding: 0 15px 0 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.s4s-illegal-ft {
  padding: 10px 0;
  border-top: 1px rgba(0, 0, 0, 0.05) solid;
  font-size: 14px;
  color: #f55d4c;
}
.s4s-illegal-tips {
  border-top: 1px rgba(0, 0, 0, 0.05) solid;
  padding: 10px 0;
  font-size: 14px;
  color: #f40;
}
.s4s-illegal-btn {
  border-top: 1px rgba(0, 0, 0, 0.05) solid;
  padding: 10px 0;
  text-align: right;
}
.s4s-illegal-btn text {
  /* border: 1px #f40 solid; */
  border-radius: 4px;
  padding: 3px 5px;
  color: #fff;
  font-size: 15px;
  background-color: #00a1ee;
}

.car-btn {
  margin: 20px 10px 10px;
  border: none;
  border-radius: 4px;
  padding: 3px 5px;
  color: #fff;
  font-size: 15px;
  background-color: #00a1ee;
}
.car-btn-delete {
  margin: 20px 0 10px;
  border-radius: 4px;
  padding: 3px 5px;
  font-size: 15px;
  background-color: rgba(0, 0, 0, 0);
  color: #115FF8;
  border: 1px #115FF8 solid;
}

.captcha{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}
.captcha .s4s-mask{
  z-index:0;
}
.captcha-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  background-color: #fff;
  padding:15px;
  border-radius: 5px;
  padding-bottom: 0;
}
.captcha-title{
  color:#333333;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
}
.captcha-input:focus ,.captcha-input {
  outline: none;
}
.captcha-input-container {
  width: 100%;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.captcha-input-list {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.captcha-change {
  color:#6F6F6F;
  font-size: 12px;
  margin-bottom: 12.5px;
  text-align: center;
}
.captcha-input {
  min-height: 40px;
  line-height: 40px;
  font-size: 22px;
  color:#333;
  flex: 1;
  width:40px;
  border:1px solid #eaeaea;
  margin-right:10px;
  max-width: 40px;
  text-align: center;
}
.captcha-input:last-child {
  margin-right:0;
}
.captcha-btn {
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  background-image: linear-gradient(40deg, #FF7C00 0%, #FE5A00 100%);
  border-radius: 5px;
  color:#fff;
}
.captcha-keyboard {
  /* display: flex; */
  /* justify-content: space-around; */
  /* flex-wrap: wrap; */
  margin-top:25px;
}
.captcha-key-list {
  display: flex;
  justify-content: space-around;
  margin:10px;
}
.captcha-key {
  border:none;
  text-align: center;
  color:#24252D;
  font-size: 24px;
  width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.data {
  color: #24252d !important;
}
</style>
